<template>
  <div class="">
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <div
      v-else
      class="">
      <tabs
        :niveau="2"
        :links="tabList"
        :level="2"
        :mode="'emitter'"
        :current-tab="tab"
        @changeView="tab = $event"
        class="has-background-light is-border-right is-border-bottom is-border-left">
      </tabs>
      <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-right is-border-bottom is-border-left">
        <div class="field is-grouped">
          <p
            class="control"
            v-for="status in invitationStatus"
            :key="status.value">
            <label
              class="checkbox checkRadioIsHide"
              :for="status.value">
              <input
                :id="status.value"
                :name="status.name"
                type="checkbox"
                :value="status.value"
                v-model="filters.status">
              <span
                class="tag"
                :class="status.color">
                <span>{{ status.label }}</span><span class="icon"><i
                  class="far"
                  :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
              </span>
            </label>
          </p>
        </div>
      </div>
      <div
        v-if="transformedInvitation && transformedInvitation.length"
        class="columns is-multiline is-margin-top-xxsmall">
        <div
          class="column is-6"
          v-for="invitation of transformedInvitation"
          :key="invitation.pk">
          <invitation-card
            :invitation="invitation"
            @canceledInvitation="removeInvitation"
            @deleteRelation="deleteRelation"
            @updateRelationStatus="updateRelationStatus"
            class="is-height-full is-flex is-column"></invitation-card><!-- HB : classes "is-height-full is-flex is-colum" lorsque les cards doivent avoir la même hauteur  -->
        </div>
      </div>
      <div v-show="!loading && !transformedInvitation.length">
        <div class="is-padding">
          <h2 class="title is-3 has-text-weight-bold">
            Aucune invitation disponible
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ErrorMixin from '@/mixins/ErrorMixin'
import { Quickview } from '@/mixins'
import { orderBy, sortBy } from 'lodash'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'InvitationsList',
  components: {
    InvitationCard: () => import('./InvitationCard')
  },
  mixins: [ErrorMixin, Quickview],
  props: {
    companies: {
      type: Array
    },
    invitations: {
      type: Array
    }
  },
  data () {
    return {
      filters: {
        status: []
      },
      avatar: {
        background: 'has-background-success',
        icon: 'fal fa-user-tie'
      },
      tab: null,
      loading: false,
      invitationStatus: [
        { value: 'pending', label: 'En attente', color: 'is-warning' },
        { value: 'refused', label: 'Refusé', color: 'is-danger' }
      ]
    }
  },
  computed: {
    ...mapState(['currentUser', 'quickview']),
    ...mapGetters(['isPromoteur']),
    today () {
      return moment()
    },
    transformedInvitation () {
      let transformedInvitations
      if (this.invitations && this.invitations.length) {
        transformedInvitations = this.invitations.map(x => {
          if ('account_one' in x) {
            let relation = {
              type: 'relation',
              status: x.status,
              pk: x.pk,
              created_on: x.created_on,
              access: x.pre_access_list.length
            }
            if (x.account_one.pk === this.currentUser.account.pk) {
              relation.account_pk = x.account_two.pk
              relation.name = x.account_two.name
              relation.email = x.account_two.email
              relation.last_login_at = x.account_two.last_login_at
            } else {
              relation.account_pk = x.account_one.pk
              relation.name = x.account_one.name
              relation.email = x.account_two.email
            }
            let company = this.companies.find(company => {
              return company.pk === relation.account_pk
            })
            if (company) {
              relation.first_admin = company.first_admin
            }
            return relation
          } else {
            let name = x.last_name + ' ' + x.first_name
            let invitation = {
              type: 'invitation',
              status: x.status,
              pk: x.pk,
              created_on: x.created_on,
              name,
              email: x.email,
              message: x.message,
              access: x.pre_access_list.length
            }
            return invitation
          }
        })
      } else {
        transformedInvitations = []
      }
      if (this.filters.status && this.filters.status.length) {
        transformedInvitations = transformedInvitations.filter(x => this.filters.status.includes(x.status))
      }
      return orderBy(transformedInvitations, x => {
        return x.created_on
      }, 'asc')
    },
    tabList () {
      let tabs = []
      if (this.isPromoteur) {
        tabs.push({ label: `Envoyé (${this.invitations.length})`, link: 'SENT_INVITATION' })
      } else {
        tabs.push({ label: `Reçu (${this.invitations.length})`, link: 'RECEIVED_INVITATION' })
      }
      return tabs
    }
  },
  created () {
    this.init()
  },
  methods: {
    async updateRelationStatus (relationPk, status) {
      try {
        await this.$api.patch(this.$resources.ACCOUNT_RELATION, relationPk, {
          status
        })
        if (status === 'refused') {
          this.$toasted.global.success('Relation refusée')
        }
        if (status === 'accepted') {
          await this.getAccounts()
          this.$toasted.global.success('Relation acceptée')
          this.$router.push({ name: 'RelationsList' })
        }
        this.$emit('reload')
      } catch (e) {
        this.$toasted.global.danger('Impossible de modifier cette relation')
      }
    },
    async getAccounts () {
      const params = {
        status: 'accepted'
      }
      const request = await this.$api.get(this.$resources.ACCOUNT_RELATION, params)
      let accounts = []
      if (this.currentUser && this.currentUser.account && this.currentUser.account.account_type === 'promoteur') {
        accounts = request.data.items.map(x => x.account_two)
      } else if (this.currentUser && this.currentUser.account && this.currentUser.account.account_type === 'commercial') {
        accounts = request.data.items.map(x => x.account_one)
      }
      const myAccount = {
        name: this.currentUser.account.name,
        pk: this.currentUser.account.pk
      }
      accounts.push(myAccount)
      accounts = sortBy(accounts, x => x.name)
      this.$store.commit('setAccounts', { accounts })
    },
    confirmDelete () {
      return this.$swal({
        title: 'Annulation invitation',
        text: 'L\'annulation de l\'invitation supprimera les mandats pré-sélectionnés.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteRelation (relationPk) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCOUNT_RELATION, relationPk)
          this.$toasted.global.success('Invitation supprimée')
        } catch (e) {
          this.$toasted.global.danger('Impossible de supprimer cette invitation')
        }
        this.$emit('reload')
      }
    },
    async removeInvitation (invitationPk) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.INVITATION, invitationPk)
          this.$toasted.global.success('Invitation supprimée')
        } catch (e) {
          this.$toasted.global.danger('Impossible de supprimer cette invitation')
        }
        this.$emit('reload')
      }
    },
    async init () {
      this.loading = true
      if (this.isPromoteur) {
        this.tab = 'SENT_INVITATION'
      } else {
        this.tab = 'RECEIVED_INVITATION'
      }
      this.loading = false
    },
    async getInvitations () {
      let { data } = await this.$api.get(this.$resources.INVITATION)
      this.invitations = data.items
    },
    async getRelations () {
      let status
      if (this.isPromoteur) {
        status = ['refused', 'pending']
      } else {
        status = 'pending'
      }
      let payload = {
        status
      }
      let { data } = await this.$api.get(this.$resources.ACCOUNT_RELATION, payload)
      this.relations = data.items
    }
  }
}
</script>
